// extracted by mini-css-extract-plugin
module.exports = {"container":"FormCategory_container__3Qdqg","label":"FormCategory_label__1BqOL","description":"FormCategory_description__GQopX"};